import { Component, OnInit } from '@angular/core';
import { PageComponent, PageService, Page, AppConfig } from '@tytapp/common';
import { environment } from 'environment';
import { Router } from '@angular/router';

@Page('registration-benefits')
@Component({
    selector: 'tyt-registration-benefits',
    templateUrl: './registration-benefits.component.html',
    styleUrls: ['./registration-benefits.component.scss']
})
export class RegistrationBenefitsComponent extends PageComponent implements OnInit {
    constructor(
        pageService: PageService,
        private appConfig: AppConfig
    ) {
        super(pageService);
    }

    get joinUrl() {
        // CHANGE GLOBALLY (at appConfig) NOT HERE
        return environment.urls.purchase;
    }

}
